export default __webpack_public_path__ + "static/media/box-6Open.6ccefc29.jpg";